<template>
  <md-empty-state :md-label="label" :md-description="description">
    <img src="@/assets/svg/undraw_not_found_60pq.svg" class="mt-5" />
  </md-empty-state>
</template>

<script>
export default {
  name: "EmptyResult",
  props: {
    label: {
      type: String,
      default: () => "",
    },
    description: {
      type: String,
      default: () => "",
    },
  },
};
</script>
